export default __webpack_public_path__ + "static/media/favicon.1400a706.ico";